import { useNavigate } from 'react-router'
import { ReactElement, useEffect } from 'react'
import { logOutResponse } from '../../stores/AuthenticationStore'

export const LogoutListener = (): ReactElement => {
  const navigate = useNavigate()

  useEffect(() => {
    return logOutResponse.onValue(() => {
      navigate('/')
    })
  }, [])

  return null
}
